export function AddCourseModal({ activePageAdm, ClassLevel, levelDisplay, isSaving, onClose, onSubmit }) {
  return (
    <div className="modal-overlayAdmin">
      <div className="modal-contentAdmin">
        <div className="modal-header">
          <h3>Add New Course</h3>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>
        <form className="modal-form" onSubmit={onSubmit}>
          <div className="form-group">
            <label>Level</label>
            <select name="level" defaultValue={activePageAdm}>
              {ClassLevel.map((level) => (
                <option key={level} value={level}>
                  {levelDisplay[level]}
                </option>
              ))}
            </select>
          </div>
          <div className="Section_title">
            <div className="form-group">
              <label>Title</label>
              <input name="title" type="text" maxLength="50" placeholder="Ex: Mathematique" required />
            </div>
            <div className="form-group">
              <label>Icon</label>
              <input name="icon" type="text" placeholder="Ex: 📘" />
            </div>
          </div>
          <div className="form-group">
            <label>Short Description</label>
            <input name="description" type="text" placeholder="Short Description..." required />
          </div>
          <div className="form-group">
            <label>Approach</label>
            <textarea name="approach" rows="4" maxLength="1000" placeholder="Describe the pedagogical approach..." required />
          </div>
          <div className="form-group">
            <label>Subjects (separated by commas)</label>
            <input name="subjects" type="text" placeholder="Algebra, Geometry, Calculus..." required />
          </div>
          <div className="form-group">
            <label>Status</label>
            <select name="status">
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
          <div className="modal-footer">
            <button className="btn-cancel" type="button" onClick={onClose}>
              <span>Cancel</span>
            </button>
            <button type="submit" className="btn-save" disabled={isSaving}>
              <span>{isSaving ? "Creating..." : "Create Course"}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}